import { render, staticRenderFns } from "./KycFileForm.vue?vue&type=template&id=9fc3ff68&"
import script from "./KycFileForm.vue?vue&type=script&lang=js&"
export * from "./KycFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports